import React from 'react';

const Label = ({ children }) => <label className="label">{children}</label>;

export default Label;
